<template>
    <div>
        <div class="col-md-12 statbox mb-4">
            <div>
                <div class="box">
                    <span></span>
                    <span class="chart-control">
                        <i class="fad fa-print fa-lg"></i>
                        <i class="fad fa-download fa-lg"></i>
                    </span>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <line-chart v-if="page == 'acquisitions'" :settings="options" :values="data"></line-chart>
                        <bar-chart v-else :settings="options" :values="data"></bar-chart>
                    </div>
                </div>
            </div>
            <overlay :enabled="loading"></overlay>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import { mapGetters } from 'vuex'
    import notificator from '@/mixins/notificator';

    import Overlay from '@/components/Overlay.vue';

    import LineChart from '@/components/Charts/Line.vue';
    import BarChart from '@/components/Charts/Bar.vue';

    const color = ['#0e5381', '#71ba51', '#008bcf', '#5C5C60'];

    export default {
        props: ['page', 'settings', 'getData'],

        components: {Overlay, LineChart, BarChart},

        mixins: [notificator],

        data() {
            return {
                ready: false,
                loading: false,
                fields: {
                    parametersAttributes: {},
                    aggregationFrequencyAttributes: {},
                    aggregationModeAttributes: {},
                    lowerboundAttributes: {},
                    upperboundAttributes: {}
                }, 

                data: {},
                options: {},
            }
        },

        created() {   
            //Parameters
            this.fields.parametersAttributes = this.settings.parametersAttributes;
            this.fields.parametersAttributes['value']['value'] = this['selected' + this.keyword + 'Parameters'];
            
            //Aggregation frequency
            this.fields.aggregationFrequencyAttributes = this.settings.aggregationFrequencyAttributes;
            this.fields.aggregationFrequencyAttributes['value']['value'] = this['selected' + this.keyword + 'AggregationFrequency'];
            
            //Aggregation mode
            this.fields.aggregationModeAttributes = this.settings.aggregationModeAttributes;
            this.fields.aggregationModeAttributes['value']['value'] = this['selected' + this.keyword + 'AggregationMode'];
            
            //Lowerbound
            this.fields.lowerboundAttributes = this.settings.lowerboundAttributes;
            this.fields.lowerboundAttributes['value']['value'] = this['selected' + this.keyword + 'Lowerbound'];
            
            //Upperbound
            this.fields.upperboundAttributes = this.settings.upperboundAttributes;
            this.fields.upperboundAttributes['value']['value'] = this['selected' + this.keyword + 'Upperbound'];

            this.generateOptions();

            this.start();
        },

        computed: {    
            ...mapGetters([
                'token',
                'clientId',
                'selectedAcquisitionsDevices',
                'selectedAcquisitionsParameters',
                'selectedAcquisitionsAggregationFrequency',
                'selectedAcquisitionsAggregationMode',
                'selectedAcquisitionsLowerbound',
                'selectedAcquisitionsUpperbound',
                
                'selectedConsumptionsDevices',
                'selectedConsumptionsParameters',
                'selectedConsumptionsAggregationFrequency',
                'selectedConsumptionsAggregationMode',
                'selectedConsumptionsLowerbound',
                'selectedConsumptionsUpperbound',
            ]),
            
            keyword() {
                return this.getFirstLetterUppercase(this.page);
            }
        },

        watch: {
            getData() {
                if(this.getData != null) {
                    this.getTSChartData();
                }
            },
        },

        methods: {
            generateOptions() {
                switch (this.page) {
                    case 'acquisitions':
                        //1 linea
                        if(this.page == 'acquisitions' && this['selected' + this.keyword + 'Devices']['multidevice'] != undefined) {
                                this.$set(this, 'options', {
                                chart: {type: 'spline', zoomType: 'x'},
                                title: {text: null},
                                xAxis: {'type': 'datetime'},
                                yAxis: [
                                    {
                                        labels: {style: {color: 'Highcharts.getOptions().colors[0]'}},
                                        title: {text: null},
                                    }
                                ],
                                tooltip: {crosshairs: true, 'shared': true, pointFormat: '{series.name}: <b>{point.y:.1f}</b>'},
                                credits: {enabled: false},
                                plotOptions: {
                                    spline: {
                                        marker: {
                                            radius: 2,
                                            lineColor: '#666666',
                                            lineWidth: 1
                                        }
                                    },
                                    style: {
                                        fontFamily: 'Rubik'
                                    },
                                    series: {
                                        events: {
                                            // legendItemClick: 'disabled'
                                        },
                                    }
                                },
                                series: []
                            });
                        } else {
                            this.$set(this, 'options', {
                                chart: {type: 'spline', zoomType: 'x'},
                                title: {text: null},
                                xAxis: {'type': 'datetime'},
                                yAxis: [
                                    {
                                        labels: {style: {color: 'Highcharts.getOptions().colors[0]'}},
                                        // title: {text: (this.widget.attributes.paramDescription.attributeValue + ' [' + this.widget.attributes.unit.attributeValue + ']'), style: {color: 'Highcharts.getOptions().colors[0]'}},
                                        title: {text: "Valori selezionati", style: {color: 'Highcharts.getOptions().colors[0]'}},
                                    }
                                ],
                                tooltip: {crosshairs: true, 'shared': true, pointFormat: '{series.name}: <b>{point.y:.1f}</b>'},
                                credits: {enabled: false},
                                plotOptions: {
                                    spline: {
                                        marker: {
                                            radius: 2,
                                            lineColor: '#666666',
                                            lineWidth: 1
                                        }
                                    },
                                    series: {
                                        events: {
                                            legendItemClick: 'disabled'
                                        },
                                    }
                                },
                                series: []
                            });
                        }
                    break;
                    case 'consumptions':
                        //Columns
                        this.$set(this, 'options', {
                            chart: {type: 'column', zoomType: 'x'},
                            title: {text: null},
                            xAxis: {
                                type: "datetime",
                                labels: {
                                    format: "{value:%d/%m/%Y %H:%M:%S}"
                                },
                                tickInterval: 24 * 3600 * 1000
                            },
                            yAxis: [
                                {
                                    labels: {style: {color: 'Highcharts.getOptions().colors[0]'}},
                                    title: {text: "Valori selezionati", style: {color: 'Highcharts.getOptions().colors[0]'}},
                                }
                            ],
                            credits: {enabled: false},
                            plotOptions: {
                                column: {
                                    pointPadding: 0.4,
                                    borderWidth: 0
                                },
                                style: {
                                    fontFamily: 'Rubik'
                                },
                                series: {
                                    events: {
                                        legendItemClick: 'disabled'
                                    },
                                     series: {
                                        pointWidth: 20
                                    }
                                }
                            }
                        });
                    break;                                
                }

                return;
                
            },

            getFirstLetterUppercase(string) {
                return string.charAt(0).toUpperCase() + string.slice(1)
            },

            start() {
                if(this.getData != null) {
                    this.getTSChartData();
                }
            },

            generateTSChartDataRequest() {
                var offset = new Date().getTimezoneOffset();

                var deviceIds;

                if(this.page == 'acquisitions' && this['selected' + this.keyword + 'Devices']['multidevice'] != undefined) {
                    deviceIds = [];

                    for(var i = 0; i < this['selected' + this.keyword + 'Devices']['devices'].length; i++) {
                        deviceIds.push(this['selected' + this.keyword + 'Devices']['devices'][i]['device']['id']);
                    }
                } else
                    deviceIds = [this['selected' + this.keyword + 'Devices']['device']['id']];

                var request = {
                    clientId: this.clientId,
                    sessionToken: this.token,
                    deviceIds: deviceIds,
                    paramIds: [this['selected' + this.keyword + 'Parameters']],   
                    fillGap: false,                 
                };
                

                if(this.fields.lowerboundAttributes != undefined && this['selected' + this.keyword + 'Lowerbound'] != undefined) {
                    if(this.fields.lowerboundAttributes.dateFormat.value == 'DD/MM/YYYY LT') {
                        var lower = this['selected' + this.keyword + 'Lowerbound'].split(" ");
                        request['aqDatetimeLowerbound'] = moment(this['selected' + this.keyword + 'Lowerbound'] + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(lower[1], 'HH:mm').add(offset, 'minutes').format('HH:mm:ss') + 'Z';
                    } else {
                        request['aqDatetimeLowerbound'] = moment(this['selected' + this.keyword + 'Lowerbound'] + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(this['selected' + this.keyword + 'Lowerbound'] + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('HH:mm:ss') + 'Z';
                    }
                }
          
                if(this.fields.upperboundAttributes != undefined && this['selected' + this.keyword + 'Upperbound'] != undefined) {
                    if(this.fields.upperboundAttributes.dateFormat.value == 'DD/MM/YYYY LT') {
                        var upper = this['selected' + this.keyword + 'Upperbound'].split(" ");
                        request['aqDatetimeUpperbound'] = moment(this['selected' + this.keyword + 'Upperbound'] + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(upper[1], 'HH:mm').add(offset, 'minutes').format('HH:mm:ss') + 'Z';
                    } else {
                        request['aqDatetimeUpperbound'] = moment(this['selected' + this.keyword + 'Upperbound'] + ' 23:59:59', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(this['selected' + this.keyword + 'Lowerbound'] + ' 23:59:59', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('HH:mm:ss') + 'Z';
                    }
                }

                if(this['selected' + this.keyword + 'AggregationFrequency'] != undefined && this['selected' + this.keyword + 'AggregationFrequency'] != null) {
                    if(request['aggregation'] == undefined)
                        request['aggregation'] = {};
                    request['aggregation']['frequency'] = this['selected' + this.keyword + 'AggregationFrequency'];
                }
                if(this['selected' + this.keyword + 'AggregationMode'] != undefined && this['selected' + this.keyword + 'AggregationMode'] != null) {
                    if(request['aggregation'] == undefined)
                        request['aggregation'] = {};

                    request['aggregation']['mode'] = this['selected' + this.keyword + 'AggregationMode'];
                }

                request['fillGap'] = true;

                return request;
            },

            getTSChartData() {

                if(!this.ready)
                    this.overlay(true);

                this.$store
                .dispatch('getTSChartData', {request: this.generateTSChartDataRequest()})
                .catch(error => {
                    if(!this.ready)
                    this.overlay(false);

                    this.notify(this.$options.filters.notification({endpoint: 'GetTSChartData', code: error}));            

                    this.data = {};

                    if(!this.ready)
                        this.ready = true;
                })
                .then(({data}) => {
                    if(!this.ready)
                        this.overlay(false);

                    this.notify(this.$options.filters.notification({endpoint: 'GetTSChartData', code: 200}));

                    if(data != undefined && data.paramList != undefined) {
                        var tmp = {};
                        var colorIndex = 0;

                        for (let key in data.paramList) {
                            let lineColor = color[colorIndex];
                            tmp[key] = {
                                name: 'Valori selezionati',
                                type: this.page == 'acquisitions' ? 'areaspline': 'column',
                                marker: {symbol: 'circle', enabled: true, radius: 2},
                                data: data.paramList[key],
                                color: lineColor,
                                fillOpacity: 0.1,
                                lineWidth: 0.8,
                                showInLegend: false
                            };
            
                            colorIndex++;
                        }

                        this.$set(this, 'data', tmp);
                    } else
                        this.data = {};
                    
                    if(!this.ready)
                        this.ready = true;
                });          
            },
            
            overlay(action) {
                this.loading = action;
            }
        }
    }
</script>